/**
 * Created by Gustavo on 08/06/2016.
 */

import {Injectable}      from '@angular/core';
import {RequestOptions, Headers, Response, Http} from '@angular/http';
import {AppDataService} from "./app-data.service";

declare var Swal : any;

@Injectable()
export class SymplaService {
    constructor(private _http : Http, private _appData : AppDataService) {
      // Initialize Firebase
    }

    ///////////////////YOUTUBE LIVECHAT//////////////////////////


  public getEvents(token){
    return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/getSymplaEvents?token='+token);
/*
    const url = 'https://www.googleapis.com/youtube/v3/liveChat/messages?part=snippet&key='+key;
    return this._authHttp.post(url,JSON.stringify(body));*/
  }


  public checkinUser(token,eventId,number){
    return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/makeSymplaCheckin?token='+token+'&eventId='+eventId+'&ticketId='+number);

  }


    /////////////////////////////////////////////////////////////

   public getParticipants (token,eventId) {
    return this._http.get('https://us-central1-coolkids-669fa.cloudfunctions.net/getSymplaEventParticipant?token='+token+'&eventId='+eventId);

        //return this._authHttp.get('https://api.instagram.com/v1/users/self?access_token='+mytoken);
    }
  

  }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/sympla.service.ts